import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-leave-dual-policy-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip, LoaderComponent, DataTablesModule, RouterOutlet, RouterModule],
  templateUrl: './leave-dual-policy-form.component.html',
  styleUrl: './leave-dual-policy-form.component.scss'
})
export class LeaveDualPolicyFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = false;

  LeaveTypes = [] as any;
  user = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Designations = [] as any;
  Applicabilitys = [] as any;
  Filter = {
    SelectType: 'S',
    BranchId: null as any,
    ClientId: null as any,
    SiteId: null as any,
    LeaveMasterId: null as any,
    WebESSApplicabilityId: null as any,
    DesignationID: null as any,
  }
  AllDays = null as any;
  DataTable = [] as any;
  ESS_DualApplicability = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  dtoptions: DataTables.Settings = {};
  IsReset = false;

  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private combo: ComboService,
    private approvalMatrix: ApprovalMatrixService,
    private modalService: NgbModal,
    protected common: CommonService,
    private leave: LeaveService,
    protected tooltip: TooltipService,
    private router: Router,
  ) {
    this.common.getPageRights();

    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => parseInt(params['bid']) > 0 ? this.Filter.BranchId = parseInt(params['bid']) : null);
    this.route.params.subscribe(params => parseInt(params['cid']) > 0 ? this.Filter.ClientId = parseInt(params['cid']) : null);
    this.route.params.subscribe(params => parseInt(params['sid']) > 0 ? this.Filter.SiteId = parseInt(params['sid']) : null);
    this.route.params.subscribe(params => parseInt(params['lid']) > 0 ? this.Filter.LeaveMasterId = parseInt(params['lid']) : null);
    this.route.params.subscribe(params => parseInt(params['wid']) > 0 ? this.Filter.WebESSApplicabilityId = parseInt(params['wid']) : null);

    this.dtoptions = { ...this.common.commonDToptions };
    this.dtoptions.paging = false;
    this.dtoptions.ordering = false;
  }

  ngOnInit(): void {
    this.ComboLoad('Branch', this.Filter.BranchId > 0 ? false : true);
    this.ComboLoad('Designation');
    if (this.Filter.ClientId > 0) {
      this.ComboLoad('Client', false);
    }
    if (this.Filter.SiteId > 0) {
      this.ComboLoad('Site', false);
    }

    if (this.Filter.BranchId > 0 && this.Filter.ClientId > 0 && this.Filter.SiteId > 0 && this.Filter.LeaveMasterId > 0 && this.Filter.WebESSApplicabilityId > 0) {
      this.IsReset = true;
      this.ESS_LeaveDualApplicabilitySelect();
    }
    this.GetApplicability();
    this.LoadEmployeeLeaveCombo();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.Filter.WebESSApplicabilityId > 0) {
        this.IsReset = true;
        this.ESS_LeaveDualApplicabilitySelect();
      } else {
        this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.common.PageRight.IsAdd) {
        this.ESS_LeaveDualApplicability_InsertUpdate();
      }
    }
    else {
      form.submitted = true;
    }
  }

  LoadEmployeeLeaveCombo() {
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.user.UserId, ComboType: 'LeaveMasterPolicy' }).subscribe({
      next: (response) => {
        this.LeaveTypes = response.ComboLoad;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, clearChild = true) {
    this.isDisabled = true;
    if (Combotype == 'Branch') {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      if (clearChild) {
        this.Filter.BranchId = null;
        this.Filter.ClientId = null;
        this.Filter.SiteId = null;
      }

    } else if (Combotype == 'Client') {
      this.Clients = [];
      this.Sites = [];

      if (clearChild) {
        this.Filter.ClientId = null;
        this.Filter.SiteId = null;
      }
    } else if (Combotype == 'Site') {
      this.Sites = [];
      if (clearChild) {
        this.Filter.SiteId = null;
      }
    } else if (Combotype == 'Designations') {
      this.Designations = [];
    }


    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientId : 0,
      'SiteId': 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        } else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;
          }
        } else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
          }
        } else if (Combotype == 'Designation') {
          if (response.ComboLoad) {
            this.Designations = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicability() {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'LDA', WebESSApplicabilityMasterID: 0, EmpType: 'Front' }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_LeaveDualApplicabilitySelect() {
    this.isDisabled = true;
    this.DataTable = Object.values([]);
    this.leave.ESS_LeaveDualApplicabilitySelect(this.Filter).subscribe({
      next: (response) => {
        if (response && response.Table) {
          this.DataTable = Object.values(response.Table);
        }
        try {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_LeaveDualApplicability_InsertUpdate() {
    this.isDisabled = true;
    this.ESS_DualApplicability = [];

    this.DataTable.forEach((element: any) => {
      this.ESS_DualApplicability.push({
        ESS_LeaveRule_DualApplicabilityId: element.ESS_LeaveRule_DualApplicabilityID,
        SiteId: element.SiteMasterID,
        MappedId: this.Filter.WebESSApplicabilityId == 9 ? element.GradeMasterID : this.Filter.WebESSApplicabilityId == 6 ? element.DesignationMasterID : 0,
        LeaveCredit: element.LeaveCredit,
      })
    });

    this.leave.ESS_LeaveDualApplicability_InsertUpdate({
      SelectType: 'I', SiteIds: this.Filter.SiteId, LeaveMasterId: this.Filter.LeaveMasterId, EmpType: 'Front', WEBESSApplicabilityId: this.Filter.WebESSApplicabilityId,
      ESS_LeaveRule_DualApplicability: this.ESS_DualApplicability
    }).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.close();
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  AddDesignation() {
    if (this.Filter.WebESSApplicabilityId == 6) {
      if (this.Filter.DesignationID > 0) {
        if (this.DataTable.findIndex((e: any) => e.DesignationMasterID == this.Filter.DesignationID) < 0) {
          this.DataTable.push({
            ESS_LeaveRule_DualApplicabilityID: 0,
            BranchMasterID: this.Filter.BranchId,
            BranchName: this.Branchs.filter((e: any) => e.BranchMasterID == this.Filter.BranchId)[0].BranchName,
            ClientGroupMasterID: this.Filter.ClientId,
            ClientGroupName: this.Clients.filter((e: any) => e.ClientGroupMasterID == this.Filter.ClientId)[0].ClientGroupName,
            SiteMasterID: this.Filter.SiteId,
            SiteCode: this.Sites.filter((e: any) => e.SiteMasterID == this.Filter.SiteId)[0].SiteCode,
            SiteName: this.Sites.filter((e: any) => e.SiteMasterID == this.Filter.SiteId)[0].SiteName.split('-')[1],
            DesignationMasterID: this.Filter.DesignationID,
            DesignationName: this.Designations.filter((e: any) => e.DesignationMasterID == this.Filter.DesignationID)[0].DesignationName,
            LeaveCredit: 0
          });

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.toast.show({ message: 'Designation already exists', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: 'Please select designation', type: toastTypeEnum.warning });
      }
    }
  }

  Clear() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.result.then(result => {
      if (result) {
        this.IsReset = false;
        this.DataTable = Object.values([]);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      }
    });
  }

  GetApplicabilityName() {
    try {
      if (this.Filter.WebESSApplicabilityId > 0) {
        return this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.Filter.WebESSApplicabilityId)[0].ApplicabilityName;
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  }

  Delete(index: number) {
    if (this.common.PageRight.IsDelete) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to delete?';
      modalRef.result.then(result => {
        if (result) {
          this.DataTable.splice(index, 1);
        }
      });
    }
  }

  close() {
    this.router.navigate(['/setting/leavedualpolicies/']);
  }

  ApplyAllDays() {
    if (this.AllDays >= 0 && this.AllDays <= 99) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to apply for all recode?';
      modalRef.result.then(result => {
        if (result) {
          this.DataTable.map((e: any) => e.LeaveCredit = this.AllDays);
        }
      });
    } else {
      this.toast.show({ message: 'Please input day between 0 to 99', type: toastTypeEnum.warning });
    }
  }
}
